import { AxiosRequestConfig } from 'axios';
import { axiosWdw, domainEndpoint } from './axios';

const endpoint = '/topic';

export default {
  get(params: any) {
    if (!params.fieldset) {
      params.fieldset = 'config';
    }
    if (params.id && params.id.length > 0 && Array.isArray(params.id)) {
      params.id = params.id.join(',');
    }
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint,
      params: params,
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
      });
  },

  // API call for suggestion of title
  // T22487: abortController enables cancelling request
  getSuggestions(topicid: number, query: string, abortController?: AbortController) {
    const param = { query: query };
    const axiosData: AxiosRequestConfig = {
      method: 'GET',
      url: domainEndpoint() + endpoint + '/' + topicid + '/thought_suggestions',
      params: param,
    };
    if (abortController) {
      axiosData.signal = abortController.signal;
    }
    return axiosWdw(axiosData)
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        // may be cancelled due to error on server or request is cancelled by user
        // console.log(error);
      });
  },

  getItem(id: number) {
    return axiosWdw({
      method: 'GET',
      url: domainEndpoint() + endpoint + '/' + id,
      params: { fieldset: 'config' },
    })
      .then(response => {
        if (response && response.data.success) {
          return response.data.data;
        } else {
          console.log('error');
        }
      })
      .catch(error => {
        console.log(error);
        return error;
      });
  },

  postNewThought(topicid: number, params: any, files: Map<string, any>) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(params));

      files.forEach((value, key) => {
        formdata.append(key, value);
      });

      return axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint + '/' + topicid + '/thought/create',
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  putEditThought(topicid: number, thoughtid: number, params: any, files: Map<string, any>) {
    return new Promise((resolve, reject) => {
      const formdata = new FormData();
      formdata.append('data', JSON.stringify(params));

      files.forEach((value, key) => {
        formdata.append(key, value);
      });

      return axiosWdw({
        method: 'PUT',
        url: domainEndpoint() + endpoint + '/' + topicid + '/thought/' + thoughtid + '/edit',
        data: formdata,
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getAttributeStats(topicid: number, attributeid: number) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + topicid + '/stats_by_attribute',
        params: { attributeid: attributeid },
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // API call to request access for restricted topic (forum)
  requestAccess(topicid: number, params: {}) {
    return new Promise((resolve, reject) => {
      return axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + topicid + '/request_access',
        params: params,
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // API call to get initial vote-status for user
  getCurrentVoteStatus(topicid: number, params: {}) {
    return new Promise((resolve, reject) => {
      return axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + '/' + topicid + '/current_vote_status',
        params: params,
      })
        .then(response => {
          if (response && response.data.success) {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
